<script>
import chart from '@/mixins/chart'

export default {
  mixins: [chart],
  name: 'ChartHighLevelMeetings',
  methods: {
    xAxisTickFormat (value) {
      if (value === this.maxValue) {
        return `${value} meetings`
      }
      return value
    }
  },
  computed: {
    maxValue () {
      return 34
    }
  }
}
</script>

<template>
  <div class="chart-high-level-meetings p-4">
    <h4 class="text-uppercase">
      {{ chartRoute.title }}
    </h4>
    <p>Leaked internal documents reveal that from 2014 to 2016 Uber executives held more than 100 meetings with public officials from 17 countries as well as representatives of European Union institutions. They included 12 meetings with representatives of the European Commission that haven’t been publicly disclosed.</p>
    <bar-chart
      class="mb-3 small"
      :social-mode="socialMode"
      :data="$options.tsv"
      :x-axis-tick-format="xAxisTickFormat" />
    <p class="text-muted text-right small mb-0">
      Source: The Uber Files
    </p>
  </div>
</template>

<style lang="scss" scoped>
@import '../../variables.scss';

.chart-high-level-meetings {
  overflow: hidden;
  min-height: 500px;
  height: 100%;
  width: 100%;
  position: relative;
  background: white no-repeat center center;
  display: flex;
  flex-direction: column;

  h4 {
    font-family: $jumbotron-font-family;
  }

  .chart--social-mode & {
    background-color: $dark;
  }

  .chart--active-route-view & {
    height: calc(100vh - var(--app-footer-height, 0));
  }

  .bar-chart {
    &:deep(.bar-chart__labels__item),
    &:deep(.bar-chart__bars__item__value) {
      font-size: $font-size-sm;
    }
  }

}
</style>

<tsv>
label	value
European Commission official	34
Minister	19
Other public official	14
Other politician	13
European Commissioner	9
President, Prime Minister	7
High level public official	4
Vice President, Deputy Prime Minister	4
Member of Parliament	3
European Director General	1
</tsv>
